export default __webpack_public_path__ + "static/media/map-3.413b3b1b.png";